var t = {
  lastWeek: "'letzten' eeee 'um' p",
  yesterday: "'gestern um' p",
  today: "'heute um' p",
  tomorrow: "'morgen um' p",
  nextWeek: "eeee 'um' p",
  other: "P"
}, a = function(e, r, m, n) {
  return t[e];
};
const u = a;
export {
  u as default
};
